import React from "react";
import cx from "classnames";

class ButtonBar extends React.Component {
  static defaultProps = {
    baseClassName: "si-c-btnbar",
    align: "right",
  };

  render() {
    let { children, baseClassName, className, align, ...otherProps } = this.props;

    let alignName = "";

    if (align) {
      alignName = baseClassName + "--" + align;
    }

    return (
      <div className={cx(baseClassName, alignName, className)} {...otherProps}>
        {children}
      </div>
    );
  }
}

export default ButtonBar;
